import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { BaseDataManagementImportHistoryService } from '../../modules/data-management/_services/base-data-management-import-history.service';
import { baseDataManagementActions } from '../actions';

@Injectable()
export class BaseDataManagementEffects {
  loadImportHistory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(baseDataManagementActions.loadImportHistory),
      switchMap(({ page, size }) =>
        this.importHistoryService.getImportHistory(page, size).pipe(
          switchMap(({ data, pagination }) => [
            baseDataManagementActions.setImportHistory({ payload: data, pagination }),
            baseDataManagementActions.successImportHistory(),
          ]),
          catchError(() => of(baseDataManagementActions.errorImportHistory()))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly importHistoryService: BaseDataManagementImportHistoryService
  ) {}
}
